import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { selectGroupDetailsLoadable, selectGroupDetail } from './group-details.selectors';
import { LoadingGroupDetailsAction } from './group-details.actions';
import { filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var GroupDetailsFacadeService = /** @class */ (function () {
    function GroupDetailsFacadeService(store) {
        this.store = store;
        this.loadableGroupDetail$ = of();
        this.groupDetails$ = of();
        this.groupUsers$ = of();
    }
    GroupDetailsFacadeService.prototype.initialize = function (groupId) {
        this.refreshGroup(groupId);
        this.loadableGroupDetail$ = this.store.pipe(select(selectGroupDetailsLoadable(groupId)));
        var groupDetail$ = this.store.pipe(select(selectGroupDetail(groupId)), filter(function (groupDetail) { return !!groupDetail; }));
        this.groupDetails$ = groupDetail$.pipe(map(function (groupDetail) { return groupDetail.group; }));
        this.groupUsers$ = groupDetail$.pipe(map(function (groupDetail) { return groupDetail.users; }));
    };
    GroupDetailsFacadeService.prototype.refreshGroup = function (groupId) {
        this.store.dispatch(new LoadingGroupDetailsAction(groupId));
    };
    GroupDetailsFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function GroupDetailsFacadeService_Factory() { return new GroupDetailsFacadeService(i0.inject(i1.Store)); }, token: GroupDetailsFacadeService, providedIn: "root" });
    return GroupDetailsFacadeService;
}());
export { GroupDetailsFacadeService };



// WEBPACK FOOTER //
// ./src/app/access-management/state/group-details/group-details.facade.ts.pre-build-optimizer.js